import React from 'react';
import { FeatureFlagName } from 'utility/featureFlags';
import { ReactComponent as ProjectsIcon } from 'assets/icons/DocumentText.svg';
import { FunctionComponent, SVGProps } from 'react';
import { assets } from '@round/whitelabel-ui';
import { lucideIcons } from '@round/creatorbase-ui';

const { Song: SongIcon, Chart: ChartIcon, SearchIcon, DollarCircle: DollarCircleIcon } = assets;

// Create a white search icon component that wraps the original SearchIcon
const WhiteSearchIcon = (props: SVGProps<SVGSVGElement>) => {
    return React.createElement(SearchIcon, {
        ...props,
        style: {
            ...props.style,
            filter: 'brightness(0) invert(1)',
        },
    });
};

// lucide-react icons are ForwardRefExoticComponents, not FunctionComponents; wrap them to match the nav icon type.
// The legacy string-ref case in SVGProps is omitted since it isn't supported by forwardRef components.
const CreatorsIcon = (props: Omit<SVGProps<SVGSVGElement>, 'ref'>) => React.createElement(lucideIcons.Users, props);
const PoolsIcon = (props: Omit<SVGProps<SVGSVGElement>, 'ref'>) => React.createElement(lucideIcons.Layers, props);
const OutreachIcon = (props: Omit<SVGProps<SVGSVGElement>, 'ref'>) => React.createElement(lucideIcons.Radar, props);

export const CREATORBASE_ROOT_PATH = 'c';

export type NavItem = {
    title: string;
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    url: string;
    featureFlag?: FeatureFlagName;
    isIndex?: boolean;
};

export type NavItemGroup = {
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    title: string;
    items: NavItem[];
};

export const isNavItemGroup = (item: NavElement): item is NavItemGroup => {
    return (item as NavItemGroup).items !== undefined;
};

export type NavElement = NavItem | NavItemGroup;

export const isProjectDetailsPage = (pathname: string) => {
    const projectDetailsRegexp = new RegExp(/\/c\/projects\/[0-9]+\//i);
    return projectDetailsRegexp.test(pathname);
};
export const isReportPage = (pathname: string) => {
    const reportPageRegexp = new RegExp(/\/c\/reports\/[0-9]+\//i);
    return reportPageRegexp.test(pathname);
};

export const getRoutes = ({ showFinance }: { showFinance?: boolean } = {}): NavElement[] => [
    {
        title: 'Projects',
        //TODO: Replace with actual icon
        icon: ProjectsIcon,
        url: `/${CREATORBASE_ROOT_PATH}/projects/`,
    },
    {
        title: 'Songs',
        icon: SongIcon,
        url: `/${CREATORBASE_ROOT_PATH}/songs/`,
    },
    {
        title: 'Reports',
        icon: ChartIcon,
        url: `/${CREATORBASE_ROOT_PATH}/reports/`,
    },
    ...((showFinance
        ? [
              {
                  title: 'Finance',
                  icon: DollarCircleIcon,
                  items: [
                      {
                          title: 'Dashboard',
                          url: `/${CREATORBASE_ROOT_PATH}/finance/dashboard/`,
                          icon: ProjectsIcon,
                      },
                      {
                          title: 'Billing Entities',
                          url: `/${CREATORBASE_ROOT_PATH}/finance/billing-entities/`,
                          icon: ProjectsIcon,
                      },
                      {
                          title: 'Purchase Orders',
                          url: `/${CREATORBASE_ROOT_PATH}/finance/purchase-orders/`,
                          icon: ProjectsIcon,
                      },
                  ],
              },
          ]
        : []) as NavElement[]),
    {
        title: 'Creators',
        icon: CreatorsIcon,
        items: [
            {
                title: 'Outreach',
                icon: OutreachIcon,
                url: `/${CREATORBASE_ROOT_PATH}/outreach/`,
            },
            {
                title: 'Creator Explore',
                icon: WhiteSearchIcon,
                url: `/${CREATORBASE_ROOT_PATH}/creator-explore/`,
            },
            {
                title: 'Creator Pools',
                icon: PoolsIcon,
                url: `/${CREATORBASE_ROOT_PATH}/pools/`,
            },
        ],
    },
];
